(function () {
	const initSliderInScope = (scope = document) => {
		const sliders = scope.querySelectorAll(".product-card-js");

		sliders.forEach((slider) => {
			if (slider.classList.contains("swiper-initialized") || slider.swiper) return;

			const cardRoot = slider.closest(".card");
			const paginationEl =
				cardRoot?.querySelector(".product-pagination .swiper-pagination") ||
				slider.querySelector(".product-pagination .swiper-pagination");
			const nextEl =
				cardRoot?.querySelector(".product-button-group .swiper-button-next") ||
				slider.querySelector(".product-button-group .swiper-button-next");
			const prevEl =
				cardRoot?.querySelector(".product-button-group .swiper-button-prev") ||
				slider.querySelector(".product-button-group .swiper-button-prev");

			new Swiper(slider, {
				pagination: paginationEl
					? {
							el: paginationEl,
							clickable: true,
					  }
					: undefined,
				navigation:
					nextEl && prevEl
						? {
								nextEl,
								prevEl,
						  }
						: undefined,
				allowTouchMove: true,
				breakpoints: {
					990: {
						allowTouchMove: false,
					},
				},
			});
		});
	};

	const initSlider = () => initSliderInScope(document);
	window.initProductCardSliders = initSliderInScope;

	initSlider();

	document.addEventListener("shopify:section:load", function () {
		initSlider();
	});

	document.addEventListener("load-more:appended", function () {
		initSlider();
	});

	// Fallback for any async DOM appends that don't dispatch events.
	const observer = new MutationObserver((mutations) => {
		mutations.forEach((mutation) => {
			mutation.addedNodes.forEach((node) => {
				if (!(node instanceof HTMLElement)) return;
				if (
					node.matches(".product-card-js") ||
					node.querySelector(".product-card-js")
				) {
					initSliderInScope(node);
				}
			});
		});
	});
	observer.observe(document.body, { childList: true, subtree: true });
})();
